import { useRef, useState } from 'react';
import { Nullable } from 'src/types/nullable.type';
import { apiGetJourneyByAlias } from 'src/utils/journeyApi';
import { useReactConstructor } from 'src/utils/react/constructor.hook';
import { usePlayerContext } from 'src/store/player';
import { getAllNodes } from 'src/utils/journey';

/**
 * fetches journey by alias id and returns all nodes with stepId and playIndex
 */
export const useJourney = (uuid: string, params?: any): { allNodes: any; journey: any } => {
  const [journey, setJourney] = useState<Nullable<any>>(null);
  const allNodesRef = useRef<any>({});
  const playerContext = usePlayerContext();

  useReactConstructor(() => {
    const parseAllNodes = (journey: any): any => {
      let nodeOrderIndex = 1;
      return journey.steps.reduce((nodes: any, step: any) => {
        step.nodes.forEach((node: any) => {
          nodes[node.uuid] = {
            node,
            stepId: step.id,
            index: nodeOrderIndex,
          };
          nodeOrderIndex += 1;
        });
        return nodes;
      }, allNodesRef.current);
    };

    apiGetJourneyByAlias(uuid, params).then((journey) => {
      allNodesRef.current = parseAllNodes(journey);
      setJourney(journey);
      playerContext.setJourney(journey);
      playerContext.setAllNodes(getAllNodes(journey));
      playerContext.generateBrandingStyles(journey);
    });
  });

  return { allNodes: allNodesRef.current, journey: journey! };
};
